/* Hanuvier v5.8 "New Look and Feel": dark teal, gold and crimson.
   Sections built for v5.8 (class .hnv-static) carry their own styling. Every other section on
   the page keeps its content and layout and is recoloured here at load: light bands become
   dark teal, dark text becomes ivory, red accents become gold (or a crimson highlight inside
   headings), buttons become gold. Main stays hidden until this has run (see hnv-theme-head). */
(function(){
  var LOGO = 'https://cdn.shopify.com/s/files/1/0778/5326/2080/files/hnv-v3-logo-white.png';
  var CX = window.HNV_CX_IMAGES || {};

  function lum(c){
    var m = c && c.match(/rgba?\(([\d.]+),\s*([\d.]+),\s*([\d.]+)(?:,\s*([\d.]+))?/);
    if(!m) return null;
    var a = m[4] === undefined ? 1 : +m[4];
    if(a < 0.05) return null;
    return { l:(0.2126*m[1] + 0.7152*m[2] + 0.0722*m[3]) / 255, r:+m[1], g:+m[2], b:+m[3] };
  }
  function isRedC(L){ return L && L.r > 130 && L.g < 90 && L.b < 100; }

  function header(){
    document.querySelectorAll('.header__row, header-component, .header__columns').forEach(function(e){
      e.style.setProperty('background', 'transparent', 'important');
    });
    document.querySelectorAll('img.header-logo__image').forEach(function(im){
      if(im.dataset.hnv) return; im.dataset.hnv = 1;
      im.removeAttribute('srcset'); im.removeAttribute('sizes'); im.src = LOGO; im.style.objectFit = 'contain';
    });
  }

  function swapImages(root){
    if(!CX || !Object.keys(CX).length) return;
    root.querySelectorAll('img').forEach(function(im){
      var f = (im.getAttribute('src') || '').split('?')[0].split('/').pop().replace(/\.(png|jpe?g|webp)$/i,'');
      f = f.replace(/_\d+x\d*$/,'');
      if(CX[f]){
        im.removeAttribute('srcset'); im.removeAttribute('sizes');
        im.src = CX[f] + '?width=1400'; im.style.objectFit = 'cover';
      }
    });
  }

  function theme(section){
    var blocks = [].slice.call(section.querySelectorAll('section, div, aside, article, details, a, li, figure, blockquote, form, label, table, tr, td, th, input, textarea, select'));
    blocks.unshift(section);
    var orig = new Map(blocks.map(function(el){ return [el, getComputedStyle(el).backgroundColor]; }));
    function painted(el){
      var p = el.parentElement;
      while(p && p !== document.documentElement){
        var c = orig.has(p) ? orig.get(p) : getComputedStyle(p).backgroundColor;
        if(lum(c)) return c;
        p = p.parentElement;
      }
      return null;
    }
    blocks.forEach(function(el){
      var c = orig.get(el), L = lum(c); if(!L) return;
      if(L.r > 150 && L.g < 90 && L.b < 90) return;
      if(painted(el) === c){ el.classList.add('hnv-clear'); return; }
      var w = el.offsetWidth;
      if(L.l > 0.75){
        if(w > 900) el.classList.add((L.r - L.b > 8) ? 'hnv-dark2' : 'hnv-dark');
        else el.classList.add('hnv-darkcard');
      } else if(L.l < 0.5 && w > 900){ el.classList.add('hnv-dark3'); }
      else if(L.l >= 0.5){ el.classList.add('hnv-darkcard'); }
    });
    section.querySelectorAll('h1,h2,h3,h4,h5,h6,p,span,li,a,em,i,b,strong,small,div,label,summary,td,th,dt,dd,blockquote,figcaption,button').forEach(function(el){
      var cs = getComputedStyle(el), L = lum(cs.color); if(!L) return;
      if(isRedC(L)){
        if(cs.display.indexOf('inline') === 0 && el.closest('h1,h2,h3')) el.classList.add('hnv-hl');
        else el.classList.add('hnv-acc');
        return;
      }
      if(/^H\d$/.test(el.tagName)){ el.classList.add('hnv-t-iv'); return; }
      if(L.l < 0.55){
        var teal = L.g > L.r + 20;
        el.classList.add(teal && (cs.textTransform === 'uppercase' || parseFloat(cs.letterSpacing) > 1) ? 'hnv-t-gd' : 'hnv-t-tx');
      }
    });
    section.querySelectorAll('*').forEach(function(el){
      var cs = getComputedStyle(el);
      if(parseFloat(cs.borderTopWidth) || parseFloat(cs.borderBottomWidth) || parseFloat(cs.borderLeftWidth)){
        var L = lum(cs.borderTopColor) || lum(cs.borderBottomColor) || lum(cs.borderLeftColor);
        if(L && !isRedC(L)) el.classList.add('hnv-bd');
      }
    });
    section.querySelectorAll('a, button').forEach(function(b){
      var cs = getComputedStyle(b), L = lum(cs.backgroundColor);
      if(!L) return;
      if(L.r > 150 && L.g < 90) return;
      if(b.offsetWidth < 420 && parseFloat(cs.borderRadius) > 6 && (L.l < 0.35 || L.l > 0.75) && b.textContent.trim().length < 40) b.classList.add('hnv-btn');
    });
    section.querySelectorAll('img').forEach(function(im){
      if(im.offsetWidth > 380){ im.parentElement.style.overflow = 'hidden'; im.classList.add('hnv-kb'); }
    });
  }

  function reveal(root){
    if(!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function(es){
      es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target); } });
    }, { threshold: .08 });
    root.querySelectorAll('h1,h2,p,img,li,details,blockquote').forEach(function(el){
      if(el.getBoundingClientRect().top > innerHeight){ el.classList.add('hnv-rv'); io.observe(el); }
    });
  }

  function run(){
    header();
    var main = document.getElementById('MainContent');
    if(main){
      [].slice.call(main.children).forEach(function(sec){
        if(sec.querySelector('.hnv-static') || sec.classList.contains('hnv-static')) return;
        try { swapImages(sec); theme(sec); reveal(sec); } catch(e){}
      });
    }
    document.documentElement.classList.add('hnv-ready');
    setTimeout(header, 1500); setTimeout(header, 4000);
  }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();
